<template>
  <div class="dados-alimentacao-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form :group-label="$t('Racao')">
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
            <v-text-field
              v-model="fields.tipoRacao"
              v-mask="{
                mask: [Array(80).fill('X').join('')],
                tokens: { X: { pattern: /[A-zÀ-ú\s\\.0-9-]/ } },
                masked: true,
              }"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Tipo')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-autocomplete
              v-model="fields.marcaRacao"
              item-text="label"
              item-value="value"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :items="foods"
              :label="$t('Marca')"
              hide-no-data
              placeholder="Digite o nome da marca"
              :persistent-placeholder="true"
              :clearable="foodClearable"
              :loading="loadingFoods"
              @change="onSelectedFood"
              @click="onSelectedFood"
              @click:append="onClickSelectFood"
              @blur="onBlurAddCustomFood"
              @update:search-input="onUpdateSearchValueFood"
            />
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { updateData } from "@/services";
import moment from "moment";

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm },
  data() {
    return {
      foodInputValue: "",
      foodClearable: false,
      fields: {
        tipoRacao: "",
        marcaRacao: "",
      },
      loadingFoods: false,
      foods: [],
    };
  },
  watch: {
    "store.showModalDataForm"() {
      this.fields = {
        ...this.fields,
        ...this.data,
        ...{
          tipoRacao: this.$options.filters.toPT_BRCapitalize(
            this.data.tipoRacao
          ),
        },
      };

      const item = {
        label: this.$options.filters.toPT_BRCapitalize(this.fields.marcaRacao),
        value: this.fields.marcaRacao?.toLowerCase(),
      };

      this.foods.push(item);
    },
  },
  mounted() {
    const isCacheExpired = this.store.pet.foods.cachedAt
      ? moment().diff(
          moment(this.store.pet.foods.cachedAt).format(),
          "minutes"
        ) > 2
      : true;

    if (isCacheExpired) {
      this.loadingFoods = true;
      fetch(
        "https://mylifeclick-resources.s3.sa-east-1.amazonaws.com/pet_food/pt_br.json"
      )
        .then((res) => res.json())
        .then((data) => {
          let d = data.foods;
          d.splice(0, 0, this.$t("Outro"));
          d = d.map((e) => ({
            label: e,
            value: e.toLowerCase(),
          }));
          this.$store.commit("pet/setFoods", {
            cachedAt: moment().format(),
            data: d,
          });

          this._setFoods();
        })
        .catch(console.error)
        .finally(() => (this.loadingFoods = false));
    }
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);
  },
  methods: {
    _setFoods() {
      this.foods = this.store.pet.foods ? this.store.pet.foods.data || [] : [];
    },
    onSave() {
      updateData(this, "pet", this.fields);
    },
    onSelectedFood(value) {
      if (value === this.$t("Outro").toLowerCase()) {
        this.foods = [];
      }

      this.foodClearable = true;
    },
    onClickSelectFood() {
      this._setFoods();
    },
    onBlurAddCustomFood() {
      const item = {
        label: this.$options.filters.toPT_BRCapitalize(this.foodInputValue),
        value: this.foodInputValue?.toLowerCase(),
      };

      this._setFoods();

      const hasItem = this.foods.find(
        (e) => e.label?.toLowerCase() === item.label?.toLowerCase()
      );

      if (!hasItem && item?.label) {
        this.foods.push(item);
      }

      this.fields.marcaRacao = item.value;

      this.foodClearable = false;
    },
    onUpdateSearchValueFood(value) {
      this.foodInputValue = value;
    },
  },
};
</script>

<style scoped></style>
